import React from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, ShieldCheck, Award, UserCog, LogOut, Flame, CircleUser } from 'lucide-react';
import { AuthProvider, useAuth } from './auth';
import { ToastProvider, PageLoading } from './components/ui';
import LoginPage from './pages/Login';
import Dashboard from './pages/Dashboard';
import Personnel from './pages/Personnel';
import Qualifications from './pages/Qualifications';
import Watches from './pages/Watches';
import WatchDetail from './pages/WatchDetail';
import Accounts from './pages/Accounts';
import Profile from './pages/Profile';

function ProtectedRoute({ children, adminOnly }) {
  const { isAuthenticated, loading, user } = useAuth();
  if (loading) return <PageLoading />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (adminOnly && !user.isAdmin) return <Navigate to="/" replace />;
  return children;
}

function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <span className="brand-badge"><Flame size={18} /></span>
          <span>SiWa</span>
        </div>
        <NavLink to="/" end className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}><LayoutDashboard size={16} /> Übersicht</NavLink>
        <NavLink to="/wachen" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}><ShieldCheck size={16} /> Sicherheitswachen</NavLink>
        <NavLink to="/personal" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}><Users size={16} /> Dienstleistende</NavLink>
        <NavLink to="/qualifikationen" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}><Award size={16} /> Qualifikationen</NavLink>
        {user.isAdmin && <NavLink to="/accounts" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}><UserCog size={16} /> Accounts</NavLink>}
        <span className="navbar-spacer" />
        <div className="navbar-user">
          <NavLink to="/profil" className="nav-link"><CircleUser size={16} /> {user.username}</NavLink>
          <button className="btn btn-sm" onClick={logout}><LogOut size={15} /> Abmelden</button>
        </div>
      </div>
    </nav>
  );
}

function Layout({ children }) {
  return (
    <div className="app">
      <NavBar />
      <main className="main-content">{children}</main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/*" element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/wachen" element={<Watches />} />
                    <Route path="/wachen/:id" element={<WatchDetail />} />
                    <Route path="/personal" element={<Personnel />} />
                    <Route path="/qualifikationen" element={<Qualifications />} />
                    <Route path="/accounts" element={<ProtectedRoute adminOnly><Accounts /></ProtectedRoute>} />
                    <Route path="/profil" element={<Profile />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
